import { Component, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CrossPointsService } from '../../_services/cross-points.service';
import { Observable } from 'rxjs/Observable';
import { CoinConfigService } from '../../_services/coinconfig.service';
import {LineBotService} from '../../_services/line-bot.service';

@Component({
    selector: 'app-cross-points',
    templateUrl: './cross-points.component.html',
    styleUrls: ['./cross-points.component.css']
})
export class CrossPointsComponent implements OnInit {
    dtOptions: DataTables.Settings = {};
    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;
    searchWord: string;
    coinName: string;
    pairId: string;
    timeYear: string;
    timeMonth: string;
    timeDay: string;
    delayTimer: any;

    markets: Observable<any[]>;
    dataMarkets: any[] = [];
    objectMarkets: any = {};
    marketId: string;

    lineBotAlls: Observable<any[]>;
    lineBotId: number;

    typeArray : any = {
        1 : "トレンドの取得cron job",
        2 : "シグナルの取得cron job"
    };

    /*
     * filterBy = 0; // load all cross point
     * filterBy = 1; // load cross point which are created by cron job get trend
     * filterBy = 2; // load cross point which are created by cron job get signal
     */
    filterBy = 0; // default load all in Bot

    constructor(
        private crossPointsService: CrossPointsService,
        private coinConfigService: CoinConfigService,
        private lineBotService: LineBotService
    ) { }

    //get years from function initYears
    years = this.initYears();

    //get months of year
    months = this.initMonths();

    //List pairs
    pairs: any[] = [
        "BTC",
        "ETH",
        "XMR",
        "USDT",
        "JPY"
    ];

    ngOnInit() {
        this.initDataTables();

        //markets
        this.markets = this.coinConfigService.getMarkets();
        this.markets.subscribe(data => {
            this.dataMarkets = data;
            data.forEach(element => {
                this.objectMarkets[element.id] = element.name;
            });
        });

        //list all bot
        this.lineBotAlls =  this.lineBotService.getLineBot();
    }

    initDataTables() {

        let self = this;

        this.dtOptions = {
            language: {
                emptyTable: "データが存在しません"
            },
            order: [['6', "desc"]],//col 7 in table - human_time_vn
            searching: false,
            lengthChange: false,
            serverSide: true,
            pageLength: 15,
            ajax: function (parameters, callback, settings) {
                parameters["search"]["value"] = self.coinName || '';
                parameters["search"]["pair"] = self.pairId || '';

                //get param search timeYear, timeMonth & timeDay
                parameters["search"]["timeYear"] = self.timeYear || '';
                parameters["search"]["timeMonth"] = self.timeMonth || '';
                parameters["search"]["timeDay"] = self.timeDay || '';
                parameters["search"]["cronJobType"] = self.filterBy;
                self.lineBotAlls.subscribe(dataLineBot => {
                    if (dataLineBot && dataLineBot.constructor === Array && dataLineBot.length) {
                        self.coinConfigService.getMarkets().subscribe(dataMarket => {
                            parameters["search"]["market"] = self.marketId || dataMarket[0].id;
                            parameters["search"]["line_bot_id"] = self.lineBotId || dataLineBot[0].id;

                            self.crossPointsService.gets(parameters).subscribe(result => {
                                callback({
                                    draw: parameters['draw'],
                                    data: result.data,
                                    recordsTotal: result.data.length,
                                    recordsFiltered: result.recordsTotal
                                });
                            });
                        });
                    }
                });
            },
            columns: [{
                title: "コイン名",
                data: "coin_name",
                name: "coin_name",
                className: "all text-justify"
            },
            {
                title: "コイン市場名",
                data: "pair",
                name: "pair",
                className: "all text-justify"
            },
            {
                title: "シグナルタイプ",
                data: "type",
                name: "type",
                className: "text-justify"
            },
            {
                title: "クロスポイント",
                data: "current_price",
                name: "current_price",
                className: "all text-justify"
            },
            {
                title: '条件',
                data: function (data) {
                    return self.typeArray[data.cron_job_type];
                },
                name: 'cron_job_type',
                className: 'all text-justify',
            },
            {
                title: "Candlestick",
                data: function(item){
                    let candlesticks = {
                        "300" : "5分足",
                        "900" : "15分足",
                        "1800" : "30分足",
                        "3600" : "1時足",
                        "7200" : "2時足",
                        "14400" : "4時足",
                        "21600" : "6時足",
                        "43200" : "12時足",
                        "86400" : "1日足",
                    };

                    return candlesticks[item.candlestick] ? candlesticks[item.candlestick] : item.candlestick;
                },
                name: "candlestick",
                className: "all text-left"
            },
            {
                title: "クロス時刻",
                data: "human_time_vn",
                name: "human_time_vn",
                className: "all text-right"
            }],
            rowCallback: (row: Node, data: any[] | Object, index: number) => {
                if (data['same_type_count'] == 1){
                    $(row).css('background-color', '#3c8dbc');
                    $(row).css('color', '#ffffff');
                }
                return row;
            }
        };
    }

    //event change time year
    onChangeTimeYear(event) {
        //declare timeDay is ''
        this.timeDay = '';

        //if timeYear is empty 
        // => disabled + set val null to option timeMonth
        // => disabled + set val null to option timeDay
        //and else
        if (event.target.value == ''){
            $('#timeMonth').val('');
            $('#timeMonth').attr('disabled', 'disabled');
            $('#timeDay').val('');
            $('#timeDay').attr('disabled', 'disabled');
        }else{
            $('#timeMonth').removeAttr('disabled');

            //pass param to function set list days
            var yearSearch = event.target.value;
            var monthSearch = parseInt(this.timeMonth);
            this.setListDays(yearSearch, monthSearch);
        }
        //transfer value timeYear
        this.timeYear = event.target.value;
        this.rerenderDataTable();
    }

    //event change time month
    onChangeTimeMonth(event) {
        //declare timeDay is ''
        this.timeDay = '';

        //if timeMonth is empty 
        // => disabled + set val null to option timeDay
        //and else
        if (event.target.value == ''){
            $('#timeDay').val(''); 
            $('#timeDay').attr('disabled', 'disabled');
        }else{
            $('#timeDay').removeAttr('disabled');

            //pass param to function set list days
            var yearSearch = parseInt(this.timeYear);
            var monthSearch = event.target.value;
            this.setListDays(yearSearch, monthSearch);
        }
        //transfer value timeMonth
        this.timeMonth = event.target.value;
        this.rerenderDataTable();
    }

    //event change time day
    onChangeTimeDay(event) {
        //transfer value timeDay
        this.timeDay = event.target.value;
        this.rerenderDataTable();
    }

    onChange(event) {
        this.pairId = event.target.value;
        this.rerenderDataTable();
    }

    valuechange(newValue) {
        this.coinName = newValue;
        this.doSearch();
    }

    doSearch() {
        let self = this;
        clearTimeout(this.delayTimer);
        // Will do the ajax stuff aft
        this.delayTimer = setTimeout(function () {
            self.rerenderDataTable();
        }, 600);
    };

    rerenderDataTable(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
        });
    }

    //init list 10 years nearest
    initYears() {
        //get year current
        var yearCurrent = new Date().getFullYear();
        var years = [];

        //push year current into array
        years.push(
            {id: yearCurrent}
        );

        //push 10 year into array
        for (var i = 1; i < 10; i++) {
            years.push(
                {id: yearCurrent - i}
            );
        }
        return years;
    }

    initMonths() {
        var months = [];
        //push 10 year into array
        for (var i = 12; i >= 1; i--) {
            var valueMonth = i < 10 ? '0' + i : i;
            months.push(
                {
                    value : valueMonth,
                    text : i
                }
            );
        }
        return months;
    };

    //set list days from yearSearch & monthSearch
    setListDays(yearSearch, monthSearch) {
        //get last day in month
        var lastDayInMonth = new Date(yearSearch, monthSearch, 0).getDate();

        //reset option day
        $('#timeDay option').remove();

        //append option defaut all
        $('#timeDay').append($('<option>', {
            value: '',
            text: 'すべて'
        }));

        //loop to append list day
        for(var i = lastDayInMonth; i >= 1; i--){
            //concate 0 to day < 10
            var valueDay = i < 10 ? '0' + i : i;
            $('#timeDay').append($('<option>', {
                value: valueDay,
                text: i
            }));
        }
    }

    onChangeMarkets(event) {
        this.marketId = event.target.value;
        this.rerenderDataTable();
    }

    // change value line_bot_id
    onChangeLineBot(event) {
        this.lineBotId = event.target.value;
        this.rerenderDataTable();
    }

    // choose filter cron job type
    onChangeFilter(event) {
        this.filterBy = event.target.value;
        this.rerenderDataTable();
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/cross-points/cross-points.component.ts